import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { CallToAction as CallToActionBase } from "./CallToAction";

export type * from "./CallToAction";
export const CallToAction = withLoyaltyStore(CallToActionBase, "CallToAction");
